import { render, staticRenderFns } from "./InactiveFBMUsersTable.vue?vue&type=template&id=65e1eeca&scoped=true"
import script from "./InactiveFBMUsersTable.vue?vue&type=script&lang=js"
export * from "./InactiveFBMUsersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e1eeca",
  null
  
)

export default component.exports